import React from 'react';

const Error = props => {
    const { error } = props;
    let response = {};
    if (error.response) {
        if(error.response.status === 422) {
            let messages = [];
            if(error.response.data.errors){
                messages = Object.values(error.response.data.errors);
            } else {
                messages = Object.values(error.response.data.data);
            }
            response = {
                valid: false,
                errorText: messages[0][0]
            };
        }
        if(error.response.status === 500) {
            response = {
                valid: false,
                errorText: "An error occurred while processing the action"
            };
        }
        if(error.response.status === 401) {
            response = {
                valid: false,
                errorText: error.response.data.message
            };
        }
    } else {
        if(JSON.stringify(error) !== "{}") {
            response = {
                valid: false,
                errorText: error
            };
        } 
    }

    return (
        <div className={`col-12 form-group ${response.valid ? 'd-none' : ''}`}>
            <label style={{ color: 'red' }}>
                {response.errorText}
            </label>
        </div>
    );
};

export default Error;
